import * as types from './types';
import { has } from 'lodash';
import { loading, success, error } from 'State/actions';
import * as objects from './../../helpers/ApplicationHistoryObjects';

export const fetchApplicationHistory = (familyId, filter) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.APPLICATION_HISTORY_FETCHING, true));

    try {
      const url = `Application/getHistory`;
      if (filter === objects.AppHistoryFilterEnum.All) {
        filter = null;
      }
      const response = await MPWWebApi.postGenericInsertUpdate(url, {
        familyId,
        filter,
      });

      if (has(response, 'data.Data')) {
        dispatch(
          success(types.APPLICATION_HISTORY_FETCH_DATA, response.data.Data)
        );
      }
    } catch (ex) {
      dispatch(error(types.APPLICATION_HISTORY_FETCH_ERROR, ex));
    }
    dispatch(loading(types.APPLICATION_HISTORY_FETCHING, false));
  };
};

export const fetchApplication = familyId => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const response = await MPWWebApi.getGeneric(`Application/${familyId}`);
      if (has(response, 'data.Data')) {
        dispatch(
          success(types.APPLICATION_HISTORY_FETCH_APP_DATA, {
            data: response.data.Data,
          })
        );
      }
    } catch (ex) {
      dispatch(error(types.APPLICATION_HISTORY_FETCH_ERROR, ex));
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/applicationhistory/actions.js